import { createEnv } from "@t3-oss/env-nextjs";
import { z } from "zod";

const clientEnv = (name: string, defaultValue: string | undefined) => {
  if (process.env.NODE_ENV === "production") {
    return `${name}`;
  }
  return defaultValue;
};

export const env = createEnv({
  skipValidation: Boolean(process.env.SKIP_ENV_VALIDATION),
  server: {
    GOOGLE_ANALYTICS_ID: z.string().optional(),
    IDENTITY_PUBLIC_GRPC_URL: z.string().min(1),
  },
  client: {
    NEXT_PUBLIC_POSTHOG_KEY: z.string().optional(),
    NEXT_PUBLIC_POSTHOG_HOST: z.string().optional().default("/posthog"),
    NEXT_PUBLIC_UNLEASH_URL: z.string().optional(),
    NEXT_PUBLIC_UNLEASH_ENVIRONMENT: z.string().optional(),
    NEXT_PUBLIC_UNLEASH_FRONTEND_API_KEY: z.string().optional(),
    NEXT_PUBLIC_UNLEASH_CLIENT_API_KEY: z.string().optional(),
  },
  shared: {
    NODE_ENV: z.enum(["development", "production"]),
  },
  // runtime env in nextjs is strict by default
  // need to destructure process.env manually
  experimental__runtimeEnv: {
    NODE_ENV: process.env.NODE_ENV,
    NEXT_PUBLIC_POSTHOG_KEY: clientEnv("phc_DeoAkUgZBAbLa6yaNTsJvtW0dVBici181Mh6Iu98vT3", process.env.NEXT_PUBLIC_POSTHOG_KEY),
    NEXT_PUBLIC_POSTHOG_HOST: clientEnv("/posthog", process.env.NEXT_PUBLIC_POSTHOG_HOST),
    NEXT_PUBLIC_UNLEASH_URL: clientEnv("", process.env.NEXT_PUBLIC_UNLEASH_URL),
    NEXT_PUBLIC_UNLEASH_ENVIRONMENT: clientEnv(
      "development",
      process.env.NEXT_PUBLIC_UNLEASH_ENVIRONMENT,
    ),
    NEXT_PUBLIC_UNLEASH_FRONTEND_API_KEY: clientEnv(
      "",
      process.env.NEXT_PUBLIC_UNLEASH_FRONTEND_API_KEY,
    ),
    NEXT_PUBLIC_UNLEASH_CLIENT_API_KEY: clientEnv(
      "",
      process.env.NEXT_PUBLIC_UNLEASH_CLIENT_API_KEY,
    ),
  },
});
